/**
 * Formats a timestamp for literral display (ex: table or meta data)
 */
export function formatTimestamp(
  inputDate: Date | string | number,
  language: Intl.LocalesArgument,
  options: Intl.DateTimeFormatOptions = {
    dateStyle: 'medium',
  },
) {
  const date = new Date(inputDate);
  const isValidDate = !Number.isNaN(date.valueOf());

  if (!isValidDate) return '-';

  return new Intl.DateTimeFormat(language, options).format(date);
}
